export enum ResetPasswordTypeEnum {
  PASSWORD = 'PASSWORD',
  PIN = 'PIN'
}
